(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["donate-impact"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const video = root.querySelector('.hih-film');
    const sound = root.querySelector('[data-sound]');
    if (video && sound) {
      const soundState = () => { sound.textContent = video.muted ? sound.dataset.on : sound.dataset.off; sound.setAttribute('aria-pressed', String(!video.muted)); };
      sound.addEventListener('click', () => { video.muted = !video.muted; if (video.paused) video.play().catch(() => {}); soundState(); });
      video.addEventListener('volumechange', soundState);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.removeAttribute('autoplay'); video.pause(); }
      else video.play().catch(() => { video.controls = true; });
      soundState();
    }
    const input = root.querySelector('#hih-amount');
    if (!input) return;
    const range = root.querySelector('#hih-range');
    const pay = root.querySelector('[data-pay]');
    const error = root.querySelector('#hih-amount-error');
    const copy = root.querySelector('.hih-impact-copy').dataset;
    const presets = root.querySelectorAll('[data-amount]');
    const devices = [...root.querySelectorAll('[data-catalog-device]')].map(el => ({el, key:el.dataset.catalogDevice, cost:Number(el.dataset.cost), name:el.dataset.name})).filter(d=>d.cost>0).sort((a,b)=>a.cost-b.cost);
    const valid = () => Number.isSafeInteger(input.valueAsNumber) && input.valueAsNumber >= 500 && input.valueAsNumber % 100 === 0;
    const number = n => n.toLocaleString(root.dataset.locale, {maximumFractionDigits:1});
    const fill = (text, values) => text.replace(/\{(\w+)\}/g, (_,k)=>values[k] ?? '');
    function updateImpact(amount) {
      const title = root.querySelector('[data-impact-title]');
      const detail = root.querySelector('[data-impact-detail]');
      const percent = root.querySelector('[data-percent]');
      const ring = root.querySelector('[data-ring]');
      if (!devices.length) { title.textContent=copy.part; detail.textContent=copy.missing; percent.textContent='—'; return; }
      const device = devices.find(d => amount <= d.cost) || devices[devices.length-1];
      const multi = amount >= device.cost * 2;
      devices.forEach(d=>{d.el.hidden=d!==device;});
      const count=Math.floor(amount/device.cost), extra=amount%device.cost, ratio=amount/device.cost;
      root.querySelector('[data-device-name]').textContent=device.name;
      title.textContent = ratio < 1 ? copy.part : count===1 ? copy.full : count===2 ? copy.two : fill(copy.many,{count:number(count)});
      detail.textContent = multi ? fill(copy.multiple,{count:number(count),cost:number(device.cost),amount:number(amount),name:device.name}) : fill(copy.detail,{amount:number(amount),cost:number(device.cost)});
      if (multi && extra>0) detail.textContent += ' '+fill(copy.more,{extra:number(extra)});
      percent.textContent=multi ? '×'+number(count) : number(ratio*100)+'%';
      percent.style.fontSize=count>=1000?'14px':'';
      root.querySelector('[data-percent-label]').textContent=multi ? copy.unit : copy.percentLabel;
      ring.style.strokeDashoffset=String(879.65*(1-Math.min(1,ratio)));
      root.querySelectorAll('[data-milestone]').forEach(e=>e.classList.toggle('is-active',e.dataset.milestone===(multi?'multiple':device.key)));
    }
    function update() {
      const amount=input.valueAsNumber, ok=valid();
      input.style.fontSize = input.value.length > 6 ? 'clamp(24px, 7vw, 40px)' : '';
      input.setCustomValidity(ok?'':root.dataset.error);
      presets.forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.amount)===amount)));
      root.querySelector('[data-step="-100"]').disabled=ok&&amount<=500;
      root.querySelector('[data-step="100"]').disabled=false;
      if(ok) {
        const sliderAmount=Math.min(50000,amount);
        range.value=String(sliderAmount);
        range.style.setProperty('--fill',`${(sliderAmount-500)/49500*100}%`);
        range.setAttribute('aria-valuetext',`${number(sliderAmount)} EGP`);
        root.querySelectorAll('[data-total]').forEach(t=>t.textContent=number(amount));
        const url=new URL(`${root.dataset.cart}/${root.dataset.variant}:${amount/100}`,window.location.origin);
        url.searchParams.set('locale',root.dataset.locale);url.searchParams.set('ref','donate-impact');url.searchParams.set('attributes[landing_page]','donate-impact');
        for(const key of ['utm_source','utm_medium','utm_campaign','utm_content']){const value=new URLSearchParams(window.location.search).get(key);if(value&&value.length<=200)url.searchParams.set(`attributes[${key}]`,value);}
        pay.href=url.pathname+url.search;pay.removeAttribute('aria-disabled');error.hidden=true;updateImpact(amount);
      } else {
        pay.removeAttribute('href');pay.setAttribute('aria-disabled','true');error.textContent=root.dataset.error;error.hidden=false;
        root.querySelector('[data-percent]').textContent='—';root.querySelector('[data-impact-title]').textContent=copy.part;root.querySelector('[data-impact-detail]').textContent='';
      }
    }
    presets.forEach(b=>b.addEventListener('click',()=>{input.value=b.dataset.amount;update();}));
    root.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>{input.value=String(Math.max(500,(valid()?input.valueAsNumber:1000)+Number(b.dataset.step)));update();}));
    range.addEventListener('input',()=>{input.value=range.value;update();});input.addEventListener('input',update);
    pay.addEventListener('click',e=>{if(!valid()){e.preventDefault();input.reportValidity();input.focus();}});
    update();
  }
  document.querySelectorAll('[data-hih]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-hih]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
